import React from "react";
import { Link } from "react-router-dom";
import { NikLogo } from "@/components/Logo";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-16 border-t border-white/10 px-4 md:px-12 py-12 bg-[#0B0E14]">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div className="max-w-xs">
            <NikLogo />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">
              Your Entertainment. Your World. Premium movies, web series and KalamPrime Originals — streaming across India and beyond.
            </p>
            <div className="flex gap-4 mt-5 text-slate-400">
              <Instagram size={18} className="hover:text-white cursor-pointer transition-colors" />
              <Twitter size={18} className="hover:text-white cursor-pointer transition-colors" />
              <Youtube size={18} className="hover:text-white cursor-pointer transition-colors" />
              <Facebook size={18} className="hover:text-white cursor-pointer transition-colors" />
            </div>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm">
            <div>
              <div className="font-semibold text-white mb-3">Explore</div>
              <ul className="space-y-2 text-slate-400">
                <li className="hover:text-white cursor-pointer">Movies</li>
                <li className="hover:text-white cursor-pointer">Web Series</li>
                <li className="hover:text-white cursor-pointer">Originals</li>
                <li className="hover:text-white cursor-pointer">Kids</li>
              </ul>
            </div>
            <div>
              <div className="font-semibold text-white mb-3">Company</div>
              <ul className="space-y-2 text-slate-400">
                <li><Link to="/about" data-testid="footer-about-link" className="hover:text-white">About KalamPrime</Link></li>
                <li className="hover:text-white cursor-pointer">Careers</li>
                <li className="hover:text-white cursor-pointer">Press</li>
                <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-white">Contact</Link></li>
              </ul>
            </div>
            <div>
              <div className="font-semibold text-white mb-3">Legal</div>
              <ul className="space-y-2 text-slate-400">
                <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms of Use</Link></li>
                <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy</Link></li>
                <li><Link to="/cookies" data-testid="footer-cookies-link" className="hover:text-white">Cookies</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} KalamPrime Entertainment. A brand by Ishukart.</span>
          <span className="font-mono">Press Play. Enter Your World.</span>
        </div>
      </div>
    </footer>
  );
}
